export class ClientContactModel {
    contact_desc: string
    contact_no: string
    contact_ext: string
    client_contact_id: number
    client_no: number
    _default: boolean

    constructor(
        contact_desc: string,
        contact_no: string,
        contact_ext: string,
        client_contact_id: number,
        client_no: number,
        _default: boolean
    ) {
        this.contact_desc = contact_desc
        this.contact_no = contact_no
        this.contact_ext = contact_ext
        this.client_contact_id = client_contact_id
        this.client_no = client_no
        this._default = _default
    }
}